import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'
import { DEFAULT_ICON_COLOR } from '../constants/icon-consts'

export const XCircleIcon = (props?: SvgProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill={DEFAULT_ICON_COLOR}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{props?.title}</title>
    <path d="M21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12ZM14.293 8.29297C14.6835 7.90244 15.3165 7.90244 15.707 8.29297C16.0976 8.68349 16.0976 9.31651 15.707 9.70703L13.4141 12L15.707 14.293L15.7754 14.3691C16.0957 14.7619 16.0731 15.3409 15.707 15.707C15.3409 16.0731 14.7619 16.0957 14.3691 15.7754L14.293 15.707L12 13.4141L9.70703 15.707C9.31651 16.0976 8.68349 16.0976 8.29297 15.707C7.90244 15.3165 7.90244 14.6835 8.29297 14.293L10.5859 12L8.29297 9.70703L8.22461 9.63086C7.90426 9.23809 7.92685 8.65908 8.29297 8.29297C8.65908 7.92685 9.23809 7.90426 9.63086 8.22461L9.70703 8.29297L12 10.5859L14.293 8.29297ZM23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12Z" />
  </svg>
)
